import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scrolls to location.hash after route change. Uses Lenis (window.__lenis) if
// available so it plays nicely with our smooth-scroll wrapper; falls back to
// native scrollIntoView.
export default function HashScroller() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) return;
    const id = hash.replace(/^#/, "");
    const t = setTimeout(() => {
      const el = document.getElementById(id);
      if (!el) return;
      if (window.__lenis && typeof window.__lenis.scrollTo === "function") {
        window.__lenis.scrollTo(el, { offset: -80, duration: 1.4 });
      } else {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 120);
    return () => clearTimeout(t);
  }, [pathname, hash]);
  return null;
}
